module.exports = __webpack_public_path__ + "static/media/Imagen 4.2fe2983a.jpeg";